!((document, Drupal, $) => {
  'use strict';

  function searchFormChangeActions() {
    var $form = $('#search-api-form--2');
    var origForm = $form.serialize();
    var formSubmitButton = $form.find('.form-actions button');

    // Default submit button state for search form
    formSubmitButton.prop('disabled', true);

    $form.on('change input', function() {
      if ($form.serialize() !== origForm) {
        formSubmitButton.prop('disabled', false);
      } else {
        formSubmitButton.prop('disabled', true);
      }
    });
  }

  function formatTelField() {
    var phoneField = document.getElementsByClassName('input-tel')[0];
    if (phoneField) {
      phoneField.addEventListener('keyup', function() {
        var phoneValue = phoneField.value;
        var output;
        phoneValue = phoneValue.replace(/[^0-9]/g, '');
        var area = phoneValue.substr(0, 3);
        var pre = phoneValue.substr(3, 3);
        var tel = phoneValue.substr(6, 4);
        if (area.length < 3) {
          output = '(' + area;
        } else if (area.length === 3 && pre.length < 3) {
          output = '(' + area + ')' + ' ' + pre;
        } else if (area.length === 3 && pre.length === 3) {
          output = '(' + area + ')' + ' ' + pre + '-' + tel;
        }
        phoneField.value = output;
      }, {passive: true});
    }
  }

  Drupal.behaviors.autocompleteInputField = {
    // Get loading button to add/remove classes
    attach: function(context) {
      function handleInputAutocomplete(inputTarget, formFieldWrapper) {
        $.each(inputTarget, function() {
          var that = $(this);

          var submitButtonWrap = that
            .closest('form')
            .find('.submit-button-wrap');
          var formGroup = that.closest(formFieldWrapper);

          that.autocomplete({
            appendTo: formGroup
          });

          // Autocomplete search initiated.
          that.bind('autocompletesearch', function(event, ui) {
            submitButtonWrap
              .addClass('loading loading--autocomplete')
              .find('button')
              .attr('disabled', true);
          });

          // Autocomplete search opened suggestions after receiving results
          that.bind('autocompleteopen', function(event, ui) {
            submitButtonWrap
              .removeClass('loading loading--autocomplete')
              .find('button')
              .attr('disabled', false);
          });
        });
      }

      // Search page autocomplete
      handleInputAutocomplete(
        $('input.form-autocomplete#edit-fulltext'),
        '.form-field-col.fulltext'
      );

      // Search icon autocomplete - currently on prod
      handleInputAutocomplete(
        $('input.form-autocomplete#edit-fulltext--2'),
        '.form-item-fulltext'
      );

      // Search icon autocomplete - on other envs (including local)
      handleInputAutocomplete(
        $('input.form-autocomplete#edit-fulltext--3'),
        '.form-item-fulltext'
      );
    }
  };

  function addLoadingMarkup(targetEl) {
    // Adds markup for loading show/hide
    const div = document.createElement('div');

    div.className = 'lds-ring';

    div.innerHTML = `
      <div></div><div></div><div></div><div></div>
    `;

    targetEl.appendChild(div);
  }

  // For input submit buttons
  function loadingStateMarkup() {
    const targetNodes = document.querySelectorAll('.submit-button-wrap');
    targetNodes.forEach((targetNode) => {
      // Add loading markup, will be hidden by default until loading state changes
      addLoadingMarkup(targetNode);
    });
  }

  loadingStateMarkup();

  searchFormChangeActions();
  formatTelField();
})(document, Drupal, jQuery);
